module.exports = __webpack_public_path__ + "img/8.24196d26.jpg";